import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import { IIndexTypeGroup } from "../../indexTypes/model/IndexTypeGroup";
import IndexTypeGroupTreeMapper from "../service/IndexTypeGroupTreeMapper";

export default class GetIndexTypeGroupTreeInteractor {
  private resource: FindResourceEntryInteractor<IIndexTypeGroup[]>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(organisationId: number, categoryId: number) {
    return this.resource.execute(
      `organisations/${organisationId}/index-categories`,
      IndexTypeGroupTreeMapper,
      () => {},
      categoryId
    );
  }
}
